const PaymentModal = ({ isOpen, message, onClose }: any) => {
  return (
    isOpen && (
      <div
        className="modal show custom_modal"
        aria-labelledby="editModal"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Courses</h5>
            </div>
            <div className="modal-body text-center">
              <h6>{message}</h6>
            </div>
            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default PaymentModal;
